import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const StationDurationTooltipContentStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "station-duration-tooltip-content",
  },
)`
  line-height: 1.4;

  div {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }
`;
